<!--
/*
 * This file is part of OrangeHRM Inc
 *
 * Copyright (C) 2020 onwards OrangeHRM Inc
 *
 * This program is free software; you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation; either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see  http://www.gnu.org/licenses
 */
-->

<template>
  <g transform="matrix(0.100151, 0, 0, -0.100425, -6.665595, 507.144165)">
    <path
      d="M3687 4532 l-517 -517 0 -310 0 -310 -350 -350 c-378 -377 -384 -386 -361 -458 14 -40 59 -84 97 -93 13 -3 41 -3 62 1 32 6 81 51 367 336 l331 329 354 0 355 0 520 520 c285 285 517 521 514 524 -2 3 -173 24 -379 46 -206 23 -376 43 -378 44 -1 2 -21 172 -44 379 -23 208 -44 377 -47 377 -4 0 -239 -233 -524 -518z"
    />
    <path
      d="M2295 4809 c-1027 -56 -1909 -786 -2159 -1788 -113 -449 -87 -961 70 -1390 50 -136 172 -379 249 -494 186 -279 435 -524 713 -700 695 -441 1592 -487 2326 -118 548 275 962 736 1171 1305 181 491 191 1039 29 1551 -14 44 -28 82 -30 84 -3 3 -51 -41 -108 -98 l-103 -103 23 -88 c44 -170 56 -260 61 -470 7 -290 -21 -484 -109 -740 -211 -615 -709 -1109 -1328 -1314 -233 -78 -413 -106 -670 -106 -804 0 -1530 457 -1886 1185 -394 807 -231 1767 406 2405 524 523 1296 737 2003 554 l60 -15 106 105 c58 58 103 107 100 110 -2 3 -52 18 -109 35 -267 77 -529 106 -815 90z"
    />
    <path
      d="M2259 3424 c-205 -37 -396 -140 -541 -292 -87 -91 -136 -163 -189 -277 -70 -149 -83 -214 -83 -420 0 -167 2 -187 27 -270 15 -49 48 -131 73 -181 181 -365 590 -588 993 -544 135 15 227 41 346 100 343 169 555 511 555 895 0 93 -21 249 -35 263 -3 4 -57 -45 -120 -108 l-115 -115 0 -70 c-1 -247 -170 -509 -405 -624 -101 -50 -176 -70 -290 -78 -128 -8 -232 14 -364 79 -91 43 -117 62 -192 137 -75 75 -94 101 -137 192 -109 225 -109 423 0 648 44 91 62 116 137 190 47 47 115 103 151 124 83 48 205 87 295 94 l70 5 118 116 c64 64 117 120 117 123 0 12 -149 29 -243 28 -51 0 -126 -7 -168 -15z"
    />
  </g>
</template>
